import { Api } from './Api';

export const sampleApi = async ({ payload }) => {
  return await Api({
    method: 'get',
    endpoint: '/sample',
    payload,
    // headers,
  });
};

export const addBrandApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/Brands',
    payload,
    headers: { token: bearerToken() },
  });
};
export const updateBrandApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/Brands/${payload.brandId}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteBrandApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/Brands/${payload.brandId}`,
    headers: { token: bearerToken() },
  });
};

export const deleteImageApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/Image/delete`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const uploadImageApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/Image/upload?folder=brand',
    payload,
    headers: { 'Content-Type': 'multipart/form-data', token: bearerToken() },
  });
};

export const getBrandApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: '/Brands',
    payload,
    headers: { token: bearerToken() },
  });
};

export const getCategoryApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: '/Categories',
    payload,
    headers: { token: bearerToken() },
  });
};

export const addCategoryApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/Categories',
    payload,
    headers: { token: bearerToken() },
  });
};
export const updateCategoryApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/Categories/${payload.categoryId}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteCategoryApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/Categories/${payload.categoryId}`,
    headers: { token: bearerToken() },
  });
};

export const getUnitApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: '/Unit',
    payload,
    headers: { token: bearerToken() },
  });
};

export const getUnitByIdApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: `/Unit/${payload.unitId}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const addUnitApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/Unit',
    payload,
    headers: { token: bearerToken() },
  });
};
export const updateUnitApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/Unit/${payload.unitId}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteUnitApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/Unit/${payload.unitId}`,
    headers: { token: bearerToken() },
  });
};

export const getWarehouseApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: '/Warehouse',
    payload,
    headers: { token: bearerToken() },
  });
};

export const addWarehouseApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/Warehouse',
    payload,
    headers: { token: bearerToken() },
  });
};
export const updateWarehouseApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/Warehouse/${payload.warehouseId}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteWarehouseApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/Warehouse/${payload.warehouseId}`,
    headers: { token: bearerToken() },
  });
};

export const getCompanyApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: '/CompanySettings',
    payload,
    headers: { token: bearerToken() },
  });
};

export const addCompanyApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/CompanySettings',
    payload,
    headers: { token: bearerToken() },
  });
};
export const updateCompanyApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/CompanySettings/${payload.id}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const getSupplierApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: '/Suppliers',
    payload,
    headers: { token: bearerToken() },
  });
};

export const getSupplierByWarehouseIdApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: `/Suppliers/Supplierwarehouse/${payload.warehouseID}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const addSupplierApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/Suppliers',
    payload,
    headers: { token: bearerToken() },
  });
};
export const updateSupplierApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/Suppliers/${payload.supplierId}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteSupplierApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/Suppliers/${payload.supplierId}`,
    headers: { token: bearerToken() },
  });
};

export const getVariationMasterApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: '/VarientMaster',
    payload,
    headers: { token: bearerToken() },
  });
};

export const getVariationMasterByIdApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: `/VarientMaster/${payload.variationId}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const addVariationMasterApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/VarientMaster',
    payload,
    headers: { token: bearerToken() },
  });
};
export const updateVariationMasterApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/VarientMaster/${payload.varientID}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteVariationMasterApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/VarientMaster/${payload.varientID}`,
    headers: { token: bearerToken() },
  });
};

export const getProductMasterApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: '/ProductMaster',
    payload,
    headers: { token: bearerToken() },
  });
};

export const getProductMasterByIdApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: `/ProductMaster/${payload.productId}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const getProductMasterBySupplierIdApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: `/ProductMaster/GetProductMasterbysupplierID/${payload.supplierID}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const addProductMasterApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/ProductMaster',
    payload,
    headers: { token: bearerToken() },
  });
};
export const updateProductMasterApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/ProductMaster/${payload.productID}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteProductMasterApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/ProductMaster/${payload.productID}`,
    headers: { token: bearerToken() },
  });
};

export const getWarehouseStockApi = async (payload) => {
  const endpoint =
    payload === ''
      ? '/WarehouseStock/SearchProductByBrandCategory'
      : `/WarehouseStock/SearchProductByBrandCategory?searchBrandCategoryProduct=${encodeURIComponent(payload)}`;

  return await Api({
    method: 'get',
    endpoint: '/WarehouseStock',
    payload,
    headers: { token: bearerToken() },
  });
};

export const addWarehouseStockApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/WarehouseStock',
    payload,
    headers: { token: bearerToken() },
  });
};
export const updateWarehouseStockApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/WarehouseStock/${payload.warehouseStockID}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteWarehouseStockApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/WarehouseStock/${payload.warehouseStockID}`,
    headers: { token: bearerToken() },
  });
};

export const warehouseStockSearchApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: `/WarehouseStock/SearchProductByBrandCategory?searchBrandCategoryProduct=${payload}`,
    headers: { token: bearerToken() },
  });
};

export const getPurchaseOrderApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: '/PO',
    payload,
    headers: { token: bearerToken() },
  });
};

export const getPurchaseOrderByIdApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: `/PO/${payload.pohdR_ID}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const addPurchaseOrderApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/PO',
    payload,
    headers: { token: bearerToken() },
  });
};
export const updatePurchaseOrderApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/PO/${payload.pohdR_ID}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deletePurchaseOrderApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/PO/${payload.pohdR_ID}`,
    headers: { token: bearerToken() },
  });
};

export const getPurchaseOrderInvoiceApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: '/POReceivingInvoice',
    payload,
    headers: { token: bearerToken() },
  });
};

export const getPurchaseOrderInvoiceByIdApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: `/POReceivingInvoice/${payload.id}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const addPurchaseOrderInvoiceApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/POReceivingInvoice',
    payload,
    headers: { token: bearerToken() },
  });
};
export const updatePurchaseOrderInvoiceApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/POReceivingInvoice/${payload.invoiceHDR_ID}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deletePurchaseOrderInvoiceApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/POReceivingInvoice/${payload.poinvoicE_NO}`,
    headers: { token: bearerToken() },
  });
};

export const salesApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: `/sales`,
    headers: { token: bearerToken() },
    payload,
  });
};

export const loginApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/Login/signin',
    payload,
  });
};

export const userApi = async () => {
  return await Api({
    method: 'get',
    endpoint: '/Users',
    headers: { token: bearerToken() },
  });
};

export const addUserApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/Users',
    payload,
    headers: { token: bearerToken() },
  });
};

export const updateUserApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/Users/${payload.userId}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteUserApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/Users/${payload.userId}`,
    headers: { token: bearerToken() },
  });
};

export const getRolesApi = async () => {
  return await Api({
    method: 'get',
    endpoint: '/Role',
    headers: { token: bearerToken() },
  });
};

export const addRolesApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/Role',
    payload,
    headers: { token: bearerToken() },
  });
};

export const updateRolesApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/Role/${payload.roleID}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteRolesApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/Role/${payload.roleID}`,
    headers: { token: bearerToken() },
  });
};

export const getExpenseCategoryApi = async () => {
  return await Api({
    method: 'get',
    endpoint: '/ExpenseCategories',
    headers: { token: bearerToken() },
  });
};

export const addExpCategoryApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/ExpenseCategories',
    payload,
    headers: { token: bearerToken() },
  });
};

export const updateExpCategoryApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/ExpenseCategories/${payload.expCategoryID}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteExpCategoryApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/ExpenseCategories/${payload.expCategoryID}`,
    headers: { token: bearerToken() },
  });
};

export const getExpensesApi = async () => {
  return await Api({
    method: 'get',
    endpoint: '/Expenses',
    headers: { token: bearerToken() },
  });
};

export const addExpenseApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/Expenses',
    payload,
    headers: { token: bearerToken() },
  });
};

export const updateExpenseApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/Expenses/${payload.expID}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteExpenseApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/Expenses/${payload.expID}`,
    headers: { token: bearerToken() },
  });
};

export const getCustomersApi = async () => {
  return await Api({
    method: 'get',
    endpoint: '/Customers',
    headers: { token: bearerToken() },
  });
};

export const addCustomerApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/Customers',
    payload,
    headers: { token: bearerToken() },
  });
};

export const updateCustomerApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/Customers/${payload.customerID}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteCustomerApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/Customers/${payload.customerID}`,
    headers: { token: bearerToken() },
  });
};

export const getBatchApi = async () => {
  return await Api({
    method: 'get',
    endpoint: '/Batch',
    headers: { token: bearerToken() },
  });
};

export const addBatchApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/Batch',
    payload,
    headers: { token: bearerToken() },
  });
};

export const updateBatchApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/Batch/${payload.bid}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteBatchApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/Batch/${payload.bid}`,
    headers: { token: bearerToken() },
  });
};

export const getTerminalMasterApi = async () => {
  return await Api({
    method: 'get',
    endpoint: '/TerminalMasters',
    headers: { token: bearerToken() },
  });
};

export const addTerminalMasterApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/TerminalMasters',
    payload,
    headers: { token: bearerToken() },
  });
};

export const updateTerminalMasterApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/TerminalMasters/${payload.terminalId}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteTerminalMasterApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/TerminalMasters/${payload.terminalId}`,
    headers: { token: bearerToken() },
  });
};

export const getShiftApi = async () => {
  return await Api({
    method: 'get',
    endpoint: '/Shift',
    headers: { token: bearerToken() },
  });
};

export const addShiftApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/Shift',
    payload,
    headers: { token: bearerToken() },
  });
};

export const updateShiftApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/Shift/${payload.sid}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteShiftApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/Shift/${payload.sid}`,
    headers: { token: bearerToken() },
  });
};

export const getCheckInOutApi = async () => {
  return await Api({
    method: 'get',
    endpoint: '/CheckInOut',
    headers: { token: bearerToken() },
  });
};

export const addCheckInOutApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/CheckInOut',
    payload,
    headers: { token: bearerToken() },
  });
};

export const updateCheckInOutApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/CheckInOut/${payload.clockInId}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteCheckInOutApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/CheckInOut/${payload.clockInId}`,
    headers: { token: bearerToken() },
  });
};

export const getCustomerSchedulePackageApi = async () => {
  return await Api({
    method: 'get',
    endpoint: '/CustomerSchedulePackage',
    headers: { token: bearerToken() },
  });
};

export const addCustomerSchedulePackageApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/CustomerSchedulePackage',
    payload,
    headers: { token: bearerToken() },
  });
};

export const updateCustomerSchedulePackageApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/CustomerSchedulePackage/${payload.customerSchedulePackageId}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteCustomerSchedulePakageApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/CustomerSchedulePackage/${payload.customerSchedulePackageId}`,
    headers: { token: bearerToken() },
  });
};

const bearerToken = () => {
  const token = JSON.parse(localStorage.getItem('token'));
  return `Bearer ${token}`;
};

export const getProductPackageApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: '/ProductPackage',
    payload,
    headers: { token: bearerToken() },
  });
};

export const getProductPackageByIdApi = async (payload) => {
  return await Api({
    method: 'get',
    endpoint: `/ProductPackage/${payload.packageId}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const addProductPackageApi = async (payload) => {
  return await Api({
    method: 'post',
    endpoint: '/ProductPackage',
    payload,
    headers: { token: bearerToken() },
  });
};
export const updateProductPackageApi = async (payload) => {
  return await Api({
    method: 'put',
    endpoint: `/ProductPackage/${payload.packageId}`,
    payload,
    headers: { token: bearerToken() },
  });
};

export const deleteProductPackageApi = async (payload) => {
  return await Api({
    method: 'delete',
    endpoint: `/ProductPackage/${payload.packageId}`,
    headers: { token: bearerToken() },
  });
};
